module.exports = __webpack_public_path__ + "img/wxp.15b416bc.png";